export const GfoPaymentsFilterTabs = {
    Successful: 'Sent',
    Refunded: 'Refunded',
    All: 'all'
};
